import axios from "axios";
import Cookie from "cookie-universal";
import { getToken } from "../utils";
const cookies = Cookie();

const { CancelToken } = axios;
const source = CancelToken.source();

const apiUrl = process.env.REACT_APP_API_URL;

export const api = axios.create({
  baseURL: apiUrl,
  timeout: 50000,
  headers: {
    Accept: "application/json, text/plain, */*",
    "Content-Type": "application/json",
  },
  get cancelToken() {
    return source.token;
  },
});

api.interceptors.request.use(
  (config) => {
    const configs = { ...config };
    const token = getToken();
    if (!!token) {
      configs.headers.aphouse = getToken();
    }
    configs.headers["local-lang"] = cookies.get("lang") || "th";
    return configs;
  },
  (error) => Promise.reject(error)
);
